import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import * as navActions from '../actions/nav';

import { canViewFunc } from '../components/SidebarNav/canView';
import Sidebar from '../components/Sidebar';
import Breadcrumb from '../components/Breadcrumb';

import { siteTitle } from '../constants';

const propTypes = {
  children: PropTypes.node.isRequired,
  metaTitle: PropTypes.string.isRequired,
  setNav: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  authority: PropTypes.object.isRequired,
  // FIXME why are we passing property into the layout? Is it for permissions
  // or 404 checks?
  property: PropTypes.object.isRequired,
  serverError: PropTypes.object.isRequired
};

/**
 * is404 checks if the serverError indicates a 404 Not Found error
 *
 * @param {object} serverError
 * @returns {boolean}
 * @api private
 */

const is404 = (serverError = {}) => {
  return serverError.hasError && serverError.type === 'RecordNotFound'
}

const Layout = ({
  children,
  metaTitle,
  match,
  setNav,
  authority,
  property,
  serverError
}) => {
  const [is404Error, setIs404Error] = useState(false)

  useEffect(() => {
    setIs404Error(is404(serverError))
  }, [serverError])

  useEffect(() => {
    const filterfn = canViewFunc(authority).bind(null, property);
    setNav(match, filterfn);

    return () => {};
  }, [match]);

  return (
    <Fragment>
      <Helmet>
        <title>
          {metaTitle} | {siteTitle}
        </title>
      </Helmet>
        <main style={{ minHeight: 'calc(100vh - 69px)' }} className="sm:flex">
          {!is404Error && <Sidebar />}
          <div className="w-48 hidden lg:block" />
          <div className="flex-1 bg-gray-100">
            {!is404Error && <Breadcrumb />}
            {!is404Error && (
              <div id="body" className="flex justify-center p-4">
                {children}
              </div>
            )}
            {is404Error && (
              <div className="p-4">
                <h2 className="font-bold text-lg mb-2">{serverError.type}</h2>
                <p>The requested resource could not be found.</p>
                <p>Status code: {serverError.status}</p>
              </div>
            )}
          </div>
        </main>
    </Fragment>
  );
};

Layout.propTypes = propTypes;

export default compose(
  withRouter,
  connect(
    (state) => ({
      authority: state.auth.authority,
      property: state.property.data,
      navs: state.nav.data,
      isLoading: state.nav.isLoading,
      serverError: state.serverError
    }),
    { ...navActions }
  )
)(Layout);
